import React from 'react';
import '../App.css';

import experience from './../images/new/5_years_of_experience.svg';
import warranty from './../images/new/10_years_warranty.svg';
import homes from './../images/new/500_homes_delivered.svg';
import quality from './../images/new/Assured_Quality.svg';
import custom from './../images/new/custom_design_solutions.svg';
import timely from './../images/new/timely_project_completion.svg';

import AOS from 'aos';
import 'aos/dist/aos.css';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

// Initialize AOS
AOS.init();

const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 6,
        slidesToSlide: 1
    },
    tablet: {
        breakpoint: { max: 1024, min: 768 },
        items: 3,
        slidesToSlide: 1
    },
    mobile: {
        breakpoint: { max: 768, min: 0 },
        items: 2,
        slidesToSlide: 1
    }
};

export default class Mission extends React.Component {
    render() {
        return (
            <div className="">
                <div style={{
                    backgroundColor: '#ffffff',
                    padding: '20px 0', /* Reduced from 40px */
                    borderRadius: '5px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                }}>
                    <div className="container aboutUs-custom-top container-sm" style={{marginTop: '10px', marginBottom: '10px'}}>
                        <div id="#scrolly-div" className="row add-mobile-padding">
                            <div className="col-sm-6 col-md-6 mt-sm-5">
                                <div className="row mt-sm-5">
                                    <div data-aos="fade-right" data-aos-duration="1000" className="col-2 col-sm-1">
                                        <span><hr className="slash"></hr></span>
                                    </div>
                                    <div className="col-10 col-sm-11">
                                        <p data-aos="fade-left" data-aos-duration="1000" className="about-topic">WHY CHOOSE US</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <p className="about-sub-topic">
                                        <span style={{ color: '#2c3e50' }}>WHY CHOOSE</span> 
                                        <span style={{ color: '#cd853f' }}> US?</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Carousel
                        responsive={responsive}
                        autoPlay={true}
                        infinite={true}
                        arrows={true}
                        showDots={false}
                        swipeable={true}
                        draggable={true}
                    >
                        <div className="text-center why-choose-item">
                            <img className="about-img custom-width" src={experience} alt="Experience" />
                            <p className="mt-3" style={{ margin: '12px 0 0 0', padding: 0 }}>
                                <span style={{ display: 'block', fontSize: '14px', fontWeight: '600', marginBottom: '4px' }}>10+ years</span>
                                <span style={{ display: 'block', fontSize: '12px', fontWeight: '400', color: '#666' }}>Crafting Excellence</span>
                            </p>
                        </div>
                        <div className="text-center why-choose-item">
                            <img className="about-img custom-width" src={warranty} alt="Warranty" />
                            <p className="mt-3" style={{ margin: '12px 0 0 0', padding: 0 }}>
                                <span style={{ display: 'block', fontSize: '14px', fontWeight: '600', marginBottom: '4px' }}>15 years</span>
                                <span style={{ display: 'block', fontSize: '12px', fontWeight: '400', color: '#666' }}>Of Guaranteed Trust</span>
                            </p>
                        </div>
                        <div className="text-center why-choose-item">
                            <img className="about-img custom-width" src={homes} alt="Homes" />
                            <p className="mt-3" style={{ margin: '12px 0 0 0', padding: 0 }}>
                                <span style={{ display: 'block', fontSize: '14px', fontWeight: '600', marginBottom: '4px' }}>500+ Homes</span>
                                <span style={{ display: 'block', fontSize: '12px', fontWeight: '400', color: '#666' }}>Delivered with Care</span>
                            </p>
                        </div>
                        <div className="text-center why-choose-item">
                            <img className="about-img custom-width" src={timely} alt="Timely Delivery" />
                            <p className="mt-3" style={{ margin: '12px 0 0 0', padding: 0 }}>
                                <span style={{ display: 'block', fontSize: '14px', fontWeight: '600', marginBottom: '4px' }}>On Time</span>
                                <span style={{ display: 'block', fontSize: '12px', fontWeight: '400', color: '#666' }}>Every Time</span>
                            </p>
                        </div>
                        <div className="text-center why-choose-item">
                            <img className="about-img custom-width" src={quality} alt="Quality Materials" />
                            <p className="mt-3" style={{ margin: '12px 0 0 0', padding: 0 }}>
                                <span style={{ display: 'block', fontSize: '14px', fontWeight: '600', marginBottom: '4px' }}>Best Quality</span>
                                <span style={{ display: 'block', fontSize: '12px', fontWeight: '400', color: '#666' }}>Materials, Guaranteed</span>
                            </p>
                        </div>
                        <div className="text-center why-choose-item">
                            <img className="about-img custom-width" src={custom} alt="Custom Design" />
                            <p className="mt-3" style={{ margin: '12px 0 0 0', padding: 0 }}>
                                <span style={{ display: 'block', fontSize: '14px', fontWeight: '600', marginBottom: '4px' }}>Personalized</span>
                                <span style={{ display: 'block', fontSize: '12px', fontWeight: '400', color: '#666' }}>Designs Tailored for You</span>
                            </p>
                        </div>
                    </Carousel>
                </div>
            </div>
        );
    }
}
